<script setup lang="ts">
    /*
     * IMPORTANT: The embedded svg icon file must have styles inlined. Global classes tend to impact other icons.
     * This is because the SVGs are loaded as components and not as images.
     */

    import { computed, type Component } from 'vue';

    const props = defineProps<{
        name: string;
        size?: string;
    }>();

    const modules = import.meta.glob('/src/img/icons/*.svg', { eager: true }) as Record<
        string,
        Component
    >;

    const IconComponent = computed(() => {
        let path = `/src/img/icons/${props.name}`;

        if (!modules[path]) {
            console.error(`The icon '${props.name}' was not found.`);
            path = '/src/img/icons/blank-icon.svg';
        }

        return modules[path];
    });

    const combinedClass = computed(() => {
        return `${props.size || 'w-full h-auto'} aspect-square fill-current stroke-current flex-shrink-0`;
    });
</script>

<template>
    <component :is="IconComponent" :class="combinedClass" aria-hidden="true" />
</template>
